import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { portfolioData } from "../data";
import "./portfolio.scss";

const Portfolio = () => {
  return (
    <div className="home-portfolio">
      <h1 className="big-title">
        <FormattedMessage id="Our" defaultMessage="Our " />
        <span className="text-border">
          <FormattedMessage
            id="Portfolio"
            defaultMessage="Portfolio"
          />
        </span>
      </h1>

      <div className="flex">
        {portfolioData.map((props, i) => {
          return (
            <div className={`portfolioCard ${props.className}`}>
              <div className="img">
                <div
                  className="inner-img"
                  style={{ content: `url(${props.img})` }}
                ></div>
                <div className="types">
                  {props.types.map((type, t) => {
                    return (
                      <div key={t} className="type">
                        <h1>{type.type}</h1>
                      </div>
                    );
                  })}
                </div>
                <Link to={props.to}>
                  <FormattedMessage id="View" defaultMessage="View" />
                  <BsArrowRight />
                  <div className="circle"></div>
                </Link>
              </div>
              <h1 className="small-title">{props.text}</h1>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Portfolio;
